import GenericModal from 'components/app-components/modals/GenericModal';
import Button from 'components/app-components/ui/button';

interface BridgeCardPinSetupModalProps {
  open: boolean;
  onClose: () => void;
  /** Called when user clicks "Go to PIN setup"; implementer should fetch PIN URL and open in new tab */
  onGoToPinSetup: () => Promise<void>;
  isLoading?: boolean;
}

/**
 * Modal shown after Bridge card creation to prompt the user to set up their card PIN.
 * Guides them to the Bridge card PIN setup URL (opened in a new tab).
 */
const BridgeCardPinSetupModal: React.FC<BridgeCardPinSetupModalProps> = ({
  open,
  onClose,
  onGoToPinSetup,
  isLoading = false,
}) => {
  const handleGoToPinSetup = async () => {
    await onGoToPinSetup();
    // Keep modal open so user can click "I'll do this later" after returning, or close on success if preferred
    onClose();
  };

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      preventOutsideClick={isLoading}
      title="Set up your card PIN"
      titleCenter
      showHeaderBorder={false}
    >
      <div className="max-w-md">
        <p className="mb-6 text-center text-sm text-neutral-600">
          Your Thera Card has been created. For security, set up a PIN for your card so you can use it at ATMs and for
          in-person purchases.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
          <Button variant="outline" onClick={onClose} disabled={isLoading} className="order-2 sm:order-1">
            I&apos;ll do this later
          </Button>
          <Button
            variant="primary"
            onClick={handleGoToPinSetup}
            loading={isLoading}
            disabled={isLoading}
            className="order-1 sm:order-2"
          >
            Setup PIN
          </Button>
        </div>
      </div>
    </GenericModal>
  );
};

export default BridgeCardPinSetupModal;
